import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { TitleContext } from './Contexts';

const Title = ({ children, mobile, desktop, isDesktop }) => {
  if ((isDesktop && !desktop) || (!isDesktop && !mobile)) return null;
  return (
    <TitleContext.Consumer>
      {ref => (ref && ref.current ? ReactDOM.createPortal(children, ref.current) : null)}
    </TitleContext.Consumer>
  );
};

Title.defaultProps = {
  mobile: true,
  desktop: true,
};

Title.propTypes = {
  children: PropTypes.node,
  isDesktop: PropTypes.bool,
  mobile: PropTypes.bool,
  desktop: PropTypes.bool,
};

export default Title;
